import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MessageType } from "@shared/enums";
import { ApiRequestConfig } from "@shared/models";

import { ErrorHandlingService } from "@shared/services/util/error-handling.service";
import { catchError, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  http = inject(HttpClient);
  errorHandler = inject(ErrorHandlingService);

  get<T>(config: ApiRequestConfig): Observable<T | null> {
    return this.http.get<T>(config.url).pipe(catchError((error) => this.handleError(error, config.url)));
  }

  post<T>(config: ApiRequestConfig): Observable<T | null> {
    return this.http.post<T>(config.url, config.body).pipe(catchError((error) => this.handleError(error, config.url)));
  }

  private handleError(error: any, url: string): Observable<null> {
    // Log the error or send it to an error reporting service
    console.error(`Request to ${url} failed:`, error);

    // Here, you can handle specific error statuses or pass general messages.
    if (error.status === 404) {
      this.errorHandler.sendMessage(MessageType.NotFound);
    } else if (error.status === 500) {
      this.errorHandler.sendMessage(MessageType.ServerError);
    } else if (!window.navigator.onLine) {
      this.errorHandler.sendMessage(MessageType.Offline);
    }

    // Return an observable with a null value to ensure the consumer handles the error too.
    return of(null);
  }
}
